// Options for the Structured Lifestyle History Checklist

export const relationshipStatusOptions = [
  'Single',
  'Married',
  'Divorced',
  'Widowed',
  'Separated',
  'Domestic Partnership',
  'In a Relationship',
  'Prefer not to say',
];

export const livingSituationOptions = [
  'Living alone',
  'Living with family',
  'Living with friends/relatives',
];

export const educationLevelOptions = [
  'No formal education',
  'Primary school',
  'Lower secondary school',
  'Upper secondary school',
  'College (Associate degree)',
  'University (Bachelor\'s degree)',
  'Master\'s degree',
  'Doctorate (Ph.D.)',
];

export const employmentStatusOptions = [
  'Student',
  'Full-time employed',
  'Part-time employed',
  'Unemployed',
  'Retired',
  'Not seeking employment',
  'Homemaker',
];

export const workEnvironmentOptions = [
  'Work burnout (psychological)',
  'Night shift work',
  'Exposure to healthcare environments (infectious)',
  'Exposure to chemicals - toxins', // Assuming typo 'độc tố'
  'Exposure to biological agents (infectious)',
  'Risk of physical injury',
  'Exposure to poor or toxic air quality',
  'Exposure to prolonged sunlight',
  'Strenuous physical movements',
  'Prolonged sitting - minimal movement',
];

// Options for Tobacco/Alcohol/Drug use (consistent with backend enum)
export const substanceUseStatusOptions = ['Current', 'Former', 'Never'];
